// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.payment-heading {
  font-size: 2.5rem;
  margin-bottom: 10px;
  text-align: center;
  color: #333;
}

.payment-intro {
  text-align: center;
  font-size: 1.2rem;
  color: #555;
  margin-bottom: 30px;
}

.payment-methods {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.payment-method {
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f7f7f7;
  transition: background-color 0.3s;
}

.payment-method:hover {
  background-color: #e9f4ff; /* Light blue on hover */
}

.method-title {
  font-size: 1.8rem;
  color: #007BFF;
  margin-bottom: 15px;
}

.method-details h4 {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.method-details ol {
  margin-left: 20px;
  list-style-type: decimal;
}

.method-details ol li {
  margin-bottom: 10px;
}

.pay-online-button {
  padding: 12px 24px;
  font-size: 1.2rem;
  color: white;
  background-color: #007BFF;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 15px;
  transition: background-color 0.3s;
}

.pay-online-button:hover {
  background-color: #0056b3;
}

.payment-footer {
  text-align: center;
  font-size: 1rem;
  color: #777;
  margin-top: 30px;
}

/* Responsive Styles */
@media (max-width: 600px) {
  .payment-container {
    padding: 20px;
  }

  .payment-heading {
    font-size: 2rem;
  }

  .method-title {
    font-size: 1.5rem;
  }

  .pay-online-button {
    width: 100%;
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Payment/Payment.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".payment-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 30px;\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.payment-heading {\n  font-size: 2.5rem;\n  margin-bottom: 10px;\n  text-align: center;\n  color: #333;\n}\n\n.payment-intro {\n  text-align: center;\n  font-size: 1.2rem;\n  color: #555;\n  margin-bottom: 30px;\n}\n\n.payment-methods {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.payment-method {\n  padding: 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background-color: #f7f7f7;\n  transition: background-color 0.3s;\n}\n\n.payment-method:hover {\n  background-color: #e9f4ff; /* Light blue on hover */\n}\n\n.method-title {\n  font-size: 1.8rem;\n  color: #007BFF;\n  margin-bottom: 15px;\n}\n\n.method-details h4 {\n  font-size: 1.5rem;\n  margin-bottom: 10px;\n}\n\n.method-details ol {\n  margin-left: 20px;\n  list-style-type: decimal;\n}\n\n.method-details ol li {\n  margin-bottom: 10px;\n}\n\n.pay-online-button {\n  padding: 12px 24px;\n  font-size: 1.2rem;\n  color: white;\n  background-color: #007BFF;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 15px;\n  transition: background-color 0.3s;\n}\n\n.pay-online-button:hover {\n  background-color: #0056b3;\n}\n\n.payment-footer {\n  text-align: center;\n  font-size: 1rem;\n  color: #777;\n  margin-top: 30px;\n}\n\n/* Responsive Styles */\n@media (max-width: 600px) {\n  .payment-container {\n    padding: 20px;\n  }\n\n  .payment-heading {\n    font-size: 2rem;\n  }\n\n  .method-title {\n    font-size: 1.5rem;\n  }\n\n  .pay-online-button {\n    width: 100%;\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
